export var OverlayViewMode;
(function (OverlayViewMode) {
    /**
     * auto detect mobile or desktop mode
     * */
    OverlayViewMode["auto"] = "auto";
    /**
     * use only if you need to open overlay in desktop mode
     * */
    OverlayViewMode["desktop"] = "desktop";
    /**
     * use only if you need to open overlay in mobile mode
     * */
    OverlayViewMode["mobile"] = "mobile";
    /**
     * use if you need to open overlay in popup mode on both desktop and mobile
     * */
    OverlayViewMode["popup"] = "popup";
    /**
     * automatically detects the view mode and if the application is running on the phone,
     * it opens the overlay in mobile mode, otherwise it opens it as a popup
     * */
    OverlayViewMode["popupAuto"] = "popupAuto";
})(OverlayViewMode || (OverlayViewMode = {}));
export var OverlayViewPopupPosition;
(function (OverlayViewPopupPosition) {
    OverlayViewPopupPosition["top"] = "top";
    OverlayViewPopupPosition["bottom"] = "bottom";
    OverlayViewPopupPosition["left"] = "left";
    OverlayViewPopupPosition["right"] = "right";
    OverlayViewPopupPosition["center"] = "center";
})(OverlayViewPopupPosition || (OverlayViewPopupPosition = {}));
//# sourceMappingURL=overlay-controller.interface.js.map